module.exports = __webpack_public_path__ + "media/images/guide-thumb-2-b38d5c319205e8f83e64e7a1ec37ca0e.png";